import axios from "axios";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Header from "../Header";
import SideBar from "../SideBar";
import BundleItem from "./BundleItem";
import Contractors from "./Contractors";
import Category from "./Category";
import UpdateBundleItem from "./UpdateBundleItem";

const UpdateBundle = ({ props }) => {
  const history = useHistory();
  const params = useParams();
  const [bundleName, setBundleName] = useState("");
  const [description, setDescription] = useState("");
  const [rating, setRating] = useState("");
  const [AproximateRate, setAproximateRate] = useState("");
  const [drawing, setDrawing] = useState([]);
  const [preview, setPreview] = useState([]);
  const [materialTypeList, setMaterialTypeList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [selectedContractors, setSelectedContractors] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [bundleItems, setBundleItems] = useState([
    // {
    //   inventory: "",
    //   section: "",
    //   materialType: "",
    //   brand: "",
    //   id: 1,
    //   //   variant: "",
    // },
  ]);

  useEffect(() => {
    console.log("hhh ", params.id);
    const user = JSON.parse(localStorage.getItem("user"));
    const config = {
      headers: { authorization: `Token ${user.token}` },
    };
    axios
      .get(`${process.env.REACT_APP_API_URL}bundle/admin/get-bundle/${params.id}`, config)
      .then((res) => {
        console.log("rrr ", res.data.data);
        setBundleName(res.data.data.name);
        setDescription(res.data.data.description);
        setRating(res.data.data.rating);
        setAproximateRate(res.data.data.AproximateRate);
        setDrawing(res.data.data.drawing);
        setPreview(process.env.REACT_APP_IMAGE_URL + res.data.data.drawing);
        setBundleItems(res.data.data.itemList);
        setSelectedContractors(res.data.data.contractors);
        setSelectedCategory(res.data.data.category);
      });
  }, []);

  const handleBundleName = ({ target }) => setBundleName(target.value);
  const handleDescription = ({ target }) => setDescription(target.value);
  const handleRating = ({ target }) => setRating(target.value);
  const handleAproximateRate = ({ target }) => setAproximateRate(target.value);
  const handleFileChange = ({ target }) => {
    const data = new FormData();
    data.append("bundle", target.files[0]);
    axios.post(`${process.env.REACT_APP_API_URL}image/upload/bundle`, data, {}).then((res) => {
      console.log("res", res);
      setDrawing(res.data.path);
      setPreview(process.env.REACT_APP_IMAGE_URL + res.data.path);
    });

  };

  // const getBrandList = async () => {
  //   const response = await axios.get(
  //     `${process.env.REACT_APP_API_URL}brand/list`
  //   );
  //   console.log('brand',response);
  //   if (response.data.data) setBrandList(response.data.data);
  // };

  const getBrandList = async () => {
    axios.get(`${process.env.REACT_APP_API_URL}brand/`, {}).then((res) => {
      if (res.data.brands) setBrandList(res.data.brands);
    });
  };

  const getMaterialTypeList = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}material/list`
    );
    if (response.data.data) setMaterialTypeList(response.data.data);
  };

  const handleBundleItem = (item, index) => {
    let bundleItem = bundleItems[index]
    bundleItem.inventory = item.inventory;
    bundleItem.section = item.section;
    bundleItem.materialType = item.materialType;
    bundleItem.brand = item.brand;
    console.log("bundleItem", bundleItem);
  };

  const addBundleItem = () => {
    let bundleItem = {
      inventory: "",
      section: "",
      materialType: "",
      brand: "",
      //   variant: "",
      // generate random mongodb id
      _id: generateMongoDBIdString(),
    };
    let newBundleItemList = [...bundleItems, bundleItem];
    setBundleItems(newBundleItemList);
  };

  const generateRandomHex = (length) => {
    return [...Array(length)].map(() => Math.floor(Math.random() * 16).toString(16)).join('');
  }
  
  const generateMongoDBIdString = () => {
    const timestamp = (new Date().getTime() / 1000 | 0).toString(16); // Convert timestamp to hexadecimal
    const machineId = Math.floor(Math.random() * 16777216).toString(16); // Random 3-byte machine identifier
    const processId = generateRandomHex(4); // Random 4-character hexadecimal process ID
    const counter = Math.floor(Math.random() * 16777216).toString(16); // Random 3-byte counter
  
    // Ensure the strings are of a fixed length
    const parts = [timestamp, machineId, processId, counter];
  
    // Check for null or undefined values and provide a default value of '0' for each part
    const idString = parts.map(part => (part || '0')).join('');
  
    return idString;
  }

  const removeBundleItem = (id) => {
    console.log('id',id);
    if (bundleItems.length === 1) return;
    console.log("id", id);
    const bundleItemList = bundleItems.filter((i) => i.id !== id && i._id !== id);
    // const bundleItemList = bundleItems.filter(
    //   (i) => i.id !== id && i._id !== id
    // );
    setBundleItems(bundleItemList);
  };

  const createRequestBody = () => {
    const data = new FormData();
    data.append("name", bundleName);
    data.append("bundleItems", JSON.stringify(bundleItems));
    data.append("drawing", drawing);
    data.append("description", description);
    data.append("rating", rating);
    data.append("AproximateRate", AproximateRate);
    console.log("selectedContractors", selectedContractors);
    const contractorIds = selectedContractors.map(
      (contractor) => contractor.value
    );
    data.append("contractorIds", JSON.stringify(contractorIds));
    const categoryId = selectedCategory;
    console.log("categoryId", categoryId);
    data.append("categoryId", JSON.stringify(categoryId));
    return data;
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setIsDisabled(true);
      const user = JSON.parse(localStorage.getItem("user"));
      const data = createRequestBody();
      
      const config = {
        headers: { authorization: `Token ${user.token}` },
      };
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}bundle/update-bundle/${params.id}`,
        data,
        config
      );
      URL.revokeObjectURL(preview);
      if (response) {
        history.push("/admin/view-bundle");
      }
      setIsDisabled(false);
    } catch (error) {
      console.log("error", error);
      setIsDisabled(false);
    }
  };

  useEffect(() => {
    // getCategoryList();
    getMaterialTypeList();
    getBrandList();
  }, []);

  console.log("bundleItems", bundleItems);

  const handleCategoryChange = ({ target }) => {
    setSelectedCategory(target.value);
  };

  const handleContractorsChange = (data) => {
    setSelectedContractors(data);
    console.log("contraId", data);
  };

  // const handleContractorsChange = (value) => {
  //   setSelectedContractors({selectedContractors:value});
  //   console.log('contraId',selectedCategory);
  // };

  return (
    <>
      <Header />
      <div className="container-fluid">
        <div className="row">
          <SideBar />
          <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
              <h1 className="h2 fw-bold">Update Bundle</h1>
            </div>

            <div className="col-md-6">
              <form onSubmit={handleSubmit}>
                <div className="row mb-4">
                  <div className="col">
                    <div className="form-outline mb-4">
                      <label className="form-label" htmlFor="weight">
                        Bundle Name
                      </label>
                      <input
                        type="text"
                        id="bundleName"
                        className="form-control"
                        name="bundleName"
                        required
                        onChange={handleBundleName}
                        value={bundleName}
                      />
                    </div>
                  </div>
                </div>
                <div className="row mb-4">
                  <div className="col">
                    <div className="form-outline">
                      <label className="form-label" htmlFor="drawing">
                        Drawing
                      </label>
                      <input
                        type="file"
                        id="drawing"
                        accept="image/png, image/jpeg"
                        className="form-control"
                        onChange={handleFileChange}
                        // required
                      />
                    </div>
                    {preview && (
                      <img
                        alt=""
                        className="uploaded-preview mt-4"
                        src={preview}
                      />
                    )}
                  </div>
                </div>

                {bundleItems.map((i, index) => (
                  <UpdateBundleItem
                    key={i._id}
                    brandList={brandList}
                    // categoryList={categoryList}
                    materialTypeList={materialTypeList}
                    handleBundleItem={handleBundleItem}
                    id={i.id || i._id}
                    index={index}
                    removeBundleItem={removeBundleItem}
                    item={i}
                  />
                ))}

                <div className="form-outline row ">
                  <button type="button" className="btn" onClick={addBundleItem}>
                    <i className="bi bi-plus-circle pe-2 " />
                    Add Item
                  </button>
                </div>

                <Category
                  selectedCategory={selectedCategory}
                  onCategoryChange={handleCategoryChange}
                />

                <Contractors
                  selectedContractors={selectedContractors}
                  onContractorsChange={handleContractorsChange}
                />

                <div className="col mt-4">
                  <div className="form-outline">
                    <label className="form-label" htmlFor="materialName">
                      Description
                    </label>
                    <textarea
                      className="form-control"
                      type="text"
                      rows={3}
                      id="description"
                      value={description}
                      onChange={handleDescription}
                    ></textarea>
                  </div>
                </div>

                <div className="col mt-2">
                  <div className="form-outline">
                    <label className="form-label" htmlFor="materialName">
                      Rating (Out of 5)
                    </label>
                    <input
                      type="text"
                      id="rating"
                      className="form-control"
                      value={rating}
                      onChange={handleRating}
                    />
                  </div>
                </div>

                <div className="col mt-2">
                  <div className="form-outline">
                    <label className="form-label" htmlFor="materialName">
                      Aproximate rate
                    </label>
                    <input
                      type="text"
                      id="rating"
                      className="form-control"
                      value={AproximateRate}
                      onChange={handleAproximateRate}
                    />
                  </div>
                </div>
                {/* <div className="form-outline row mt-3 mb-4">
                  <button type="button" className="btn" onClick={addBundleItem}>
                    <i className="bi bi-plus-circle pe-2 " />
                    Add Item
                  </button>
                </div> */}
                <button
                  type="submit"
                  className="btn btn-primary2 btn-block mt-4"
                  disabled={isDisabled}
                >
                  Update Bundle
                </button>
              </form>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default UpdateBundle;
